import { SortOrder } from '@constants/common.constants';
import { IPaginatedFetchRequest } from '@common-actions/paginatedFetch.types';

/** API response list key for GET userHistoricalNotices. */
export const HISTORICAL_NOTICES_LIST_KEY = 'userHistoricalNotices';

/** Sort fields for GET userHistoricalNotices (member or CAP). */
export const HISTORICAL_NOTICES_SORT_FIELDS = {
    SUBJECT: 'DOCUMENT_DESCRIPTION',
    DATE_TIME: 'NOTIFICATION_SENT_ON',
} as const;

export type HistoricalNoticesSortField =
    (typeof HISTORICAL_NOTICES_SORT_FIELDS)[keyof typeof HISTORICAL_NOTICES_SORT_FIELDS];

export interface IHistoricalNotice {
    id: number;
    subject: string;
    noticeUrl: string | null;
    type: string;
    actionRequired: boolean | null;
    memberName: string;
    memberDob: string;
    dateTime: string;
}

export interface IHistoricalNoticesPageData {
    userHistoricalNotices: IHistoricalNotice[];
    totalElements: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

export interface IHistoricalNoticesListState {
    hasLoaded: boolean;
    notices: IHistoricalNotice[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    sortColumn: HistoricalNoticesSortField;
    sortOrder: SortOrder;
    hasLoadError: boolean;
}

export interface IHistoricalNoticesFetchRequest extends IPaginatedFetchRequest {
    sortColumn: HistoricalNoticesSortField;
}
